module.exports = __webpack_public_path__ + "img/laptop.218981b0.png";